import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { browserAuthGuard } from './shared/guards/browser-auth.guard';

export const rootRouterConfig: Routes = [
  {
    path: '',
    redirectTo: 'sessions/signin',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [browserAuthGuard],
    children: [
      {
        // path: 'v2',
        path: '',
        loadChildren: () =>
          import('./views/default/default.module').then((m) => m.DefaultModule),
        data: { title: 'Dashboard', breadcrumb: 'Dashboard' },
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'sessions',
        loadChildren: () =>
          import('./views/sessions/sessions.module').then(
            (m) => m.SessionsModule,
          ),
        data: { title: 'Session' },
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'secure',
        loadChildren: () =>
          import('./views/secure/secure.module').then((m) => m.SecureModule),
        data: { title: 'Sign In' },
      },
    ],
  },

  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [browserAuthGuard],
    children: [
      {
        path: '',
        //canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/default/default.module').then((m) => m.DefaultModule),
        data: { title: 'Default', breadcrumb: 'Default' },
      },
      {
        path: 'default',
        // canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/default/default.module').then((m) => m.DefaultModule),
        data: { title: 'Dashboard', breadcrumb: 'DASHBOARD' },
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
        data: { title: 'Dashboard', breadcrumb: 'DASHBOARD' },
      },
      {
        path: '',
        canActivate: [browserAuthGuard],
        loadChildren: () =>
          import('./views/outlet/outlet.module').then((m) => m.OutletModule),
        data: { title: 'Outlets', breadcrumb: 'Master Data / Outlets' },
      },
      {
        path: 'dialogs',
        loadChildren: () =>
          import('./views/app-dialogs/app-dialogs.module').then(
            (m) => m.AppDialogsModule,
          ),
        data: { title: 'Dialogs', breadcrumb: 'DIALOGS' },
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./views/profile/profile.module').then((m) => m.ProfileModule),
        data: { title: 'Profile', breadcrumb: 'PROFILE' },
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./views/tables/tables.module').then((m) => m.TablesModule),
        data: { title: 'Tables', breadcrumb: 'TABLES' },
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('./views/app-calendar/app-calendar.module').then(
            (m) => m.AppCalendarModule,
          ),
        data: { title: 'Calendar', breadcrumb: 'CALENDAR' },
      },
      {
        path: 'search',
        loadChildren: () =>
          import('./views/search-view/search-view.module').then(
            (m) => m.SearchViewModule,
          ),
      },
      {
        path: 'utilities',
        loadChildren: () =>
          import('./views/utilities/utilities.module').then(
            (m) => m.UtilitiesModule,
          ),
      },
      {
        path: 'test',
        loadChildren: () =>
          import('./views/home/home.module').then((m) => m.HomeModule),
        data: { title: 'Inbox' },
      },
      {
        path: 'inbox',
        loadChildren: () =>
          import('./views/inbox/inbox.module').then((m) => m.InboxModule),
        data: { title: 'Inbox', breadcrumb: 'Inbox' },
      },
      {
        path: 'outbox',
        loadChildren: () =>
          import('./views/outbox/outbox.module').then((m) => m.OutboxModule),
        data: { title: 'Outbox', breadcrumb: 'Outbox' },
      },
      {
        path: 'sales',
        canActivate: [browserAuthGuard],
        loadChildren: () =>
          import('./views/sales/sales.module').then((m) => m.SalesModule),
        // data: { title: '', breadcrumb: '' }
      },
      {
        path: 'gratis',
        // canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/gratis/gratis.module').then(
            (m) => m.GratisClaimModule,
          ),
        // data: { title: 'Reports', breadcrumb: 'Reports' }
      },
      {
        path: 'ringpull',
        // canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/Ringpull-Redemption/ringpull.mudule').then(
            (m) => m.RingpullModule,
          ),
      },

      {
        path: 'StockReturn',
        loadChildren: () =>
          import('./views/stock-return/stock-return.module').then(
            (m) => m.StockReturnModule,
          ),
        data: { title: 'Stock Return', breadcrumb: 'Stock Return' },
      },

      {
        path: 'contract-list',
        loadChildren: () =>
          import('./views/contract-offer/contract-list.module').then(
            (m) => m.ContractListModule,
          ),
      },

      {
        path: 'sponsorship',
        loadChildren: () =>
          import('./views/Sponsorship/sponsorship.module').then(
            (m) => m.SponsorshipModule,
          ),
        data: { title: 'Sponsorship', breadcrumb: 'Sponsorship' },
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./views/reports/reports.module').then((m) => m.ReportsModule),
      },
      {
        path: 'kegs',
        loadChildren: () =>
          import('./views/KEG/keg.module').then((m) => m.KegsModule),
      },
      {
        path: 'order-to-hb',
        loadChildren: () =>
          import('./views/order-to-hb/order-to-hb.module').then(
            (m) => m.OrderToHBModule,
          ),
      },
      {
        path: 'empty-carton',
        loadChildren: () =>
          import('./views/empty-carton/empty-carton.module').then(
            (m) => m.EmptyCartonModule,
          ),
      },
      {
        path: 'outlet-monthly-claim',
        loadChildren: () =>
          import('./views/outletMonthlyClaim/outlet-monthly-claim.module').then(
            (m) => m.OutletMonthlyClaimModule,
          ),
      },
      {
        path: 'claim-margin',
        loadChildren: () =>
          import('./views/claim-margin/claim-margin.module').then(
            (m) => m.ClaimMarginModule,
          ),
      },
    ],
  },

  {
    path: 'forbidden-403',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./views/forbidden-403/forbidden-403.module').then(
            (m) => m.Forbidden403Module,
          ),
        data: { title: 'Forbidden', breadcrumb: 'Forbidden' },
      },
    ],
  },

  {
    path: '**',
    redirectTo: 'sessions/404',
  },
];

